import { motion } from 'framer-motion'
import { Link } from '@tanstack/react-router'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide10Close.copy'

const ease = [0.16, 1, 0.3, 1] as const


export default function Slide10Close(_props: SlideProps) {
  const c = useSlideCopy(copy)
  const TAKEAWAYS = [c.takeaway1, c.takeaway2, c.takeaway3]

  return (
    <div className="flex flex-col items-center text-center px-4 mx-auto max-w-4xl">
      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15, ease }}
        className="text-4xl sm:text-6xl font-semibold text-slate-900 tracking-tight leading-[1.05]"
      >
        {c.title}
      </motion.h2>

      <div className="mt-12 w-full max-w-2xl text-start space-y-6">
        {TAKEAWAYS.map((tip, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.9 + i * 0.2, ease }}
            className="flex items-start gap-4"
          >
            <span className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-violet-100 text-violet-600 text-sm font-bold">
              {i + 1}
            </span>
            <p className="text-lg sm:text-xl leading-relaxed text-slate-600">
              {tip}
            </p>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1.8, ease }}
        className="mt-14"
      >
        <Link
          to="/basics/$basicsSlug"
          params={{ basicsSlug: 'warning-signs' }}
          className="inline-block rounded-full bg-violet-600 px-8 py-3.5 text-lg font-semibold text-white hover:bg-violet-700 transition-colors cursor-pointer"
        >
          {c.buttonLabel}
        </Link>
      </motion.div>
    </div>
  )
}
